import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import PackageFlightBooking from "./PacakgeFlightBooking";
import PackageHotelBooking from "./PackageHotelBooking";
import PackageForm from "./PackageForm";
import PackageSightSeeing from "./PackageSightSeeing";
import PackageTransfer from "./PackageTransfer";
import PackageItinerary from "./PackageItinerary";
import PackageInclude from "./PackageInclude";
import PackageExclude from "./PackageExclude";
import PackageTermsandCondition from "./PackageTermsandCondition";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import PackageTabs from "../AllTabs/PackageTabs";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import "./Package.css"

import {
  RiListCheck,
  RiPlaneLine,
  RiHotelBedLine,
  RiCameraLensLine,
  RiCarLine,
  RiMapPinLine,
  RiCheckboxCircleLine,
  RiCloseCircleLine,
  RiFileShieldLine,
  RiEyeLine,
  RiLayoutLine,
  RiGroupLine
} from "react-icons/ri";

import "./Package.css";
import PackageDetailsView from "./PackageDetailsView";
import PackageTemplates from "./PackageTemplates";
import PackageManageApplicants from "./PackageManageApplicants";

const PackageComponent = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { packageId } = useParams();
  const location = useLocation();
  const [isCreated, setIsCreated] = useState(!!packageId);
  const [isEditMode, setIsEditMode] = useState(!!packageId);
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 0);

  // 1. ADD STATE to hold the package details for all child components
  const [packageDetails, setPackageDetails] = useState(null);

  useEffect(() => {
    if (packageId) {
      setIsCreated(true);
      setIsEditMode(true);
      if (location.state?.activeTab !== undefined) {
        setActiveTab(location.state.activeTab);
      }
    } else {
      setIsCreated(false);
      setIsEditMode(false);
      setActiveTab(0);
      setPackageDetails(null); // Clear details when creating a new package
    }
  }, [packageId, location.state]);

  // 2. ADD useEffect TO FETCH DATA. This component is now the "source of truth".
  useEffect(() => {
    const getPackageDetails = async () => {
      if (packageId) {
        try {
          const response = await apiService.get(`${config.GETPACKAGEBYID}/${packageId}`);
          setPackageDetails(response.data || response);
        } catch (error) {
          console.error("Failed to fetch package details:", error);
          navigate("/package"); // Redirect if package not found
        }
      }
    };
    getPackageDetails();
  }, [packageId, navigate]); // Re-fetch if packageId changes

  const handleTabSelect = (index) => {
    setActiveTab(index);
  };
  const handleAiPackageGenerated = (newPackageId) => {
    const viewDetailsTabIndex = 9;
    navigate(`/package/${newPackageId}`, {
      state: { activeTab: viewDetailsTabIndex }
    });
  };

  useEffect(() => {
    if (!loading && !user) {
      navigate("/");
    }
  }, [user, loading, navigate]);
  useEffect(() => {
    if (location.state && location.state.activeTab !== undefined) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  if (loading) {
    return <p>Loading...</p>;
  }


  return (
     <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                <PackageTabs pageName="HOLIDAY PACKAGE" />
              </div>
              <div className="package-tabs-container">
                <div className="package-tabs-nav">
                  <Tabs selectedIndex={activeTab} onSelect={handleTabSelect}>
                    <TabList className="list-unstyled">
                      <Tab className={`package-tab-item ${activeTab === 0 ? "active" : ""}`}>
                        <RiListCheck />
                        <span>Package Form</span>
                      </Tab>
                      <Tab
                        className={`package-tab-item ${activeTab === 1 ? "active" : ""} ${!isCreated ? "disabled" : ""}`}
                        disabled={!isCreated}
                      >
                        <RiMapPinLine />
                        <span>Itineraries</span>
                      </Tab>
                      <Tab
                        className={`package-tab-item ${activeTab === 2 ? "active" : ""} ${!isCreated ? "disabled" : ""}`}
                        disabled={!isCreated}
                      >
                        <RiPlaneLine />
                        <span>Flight</span>
                      </Tab>

                      <Tab
                        className={`package-tab-item ${activeTab === 3 ? "active" : ""} ${!isCreated ? "disabled" : ""}`}
                        disabled={!isCreated}
                      >
                        <RiHotelBedLine />
                        <span>Hotel</span>
                      </Tab>
                      <Tab
                        className={`package-tab-item ${activeTab === 4 ? "active" : ""} ${!isCreated ? "disabled" : ""}`}
                        disabled={!isCreated}
                      >
                        <RiCameraLensLine />
                        <span>SightSeeing</span>
                      </Tab>
                      <Tab
                        className={`package-tab-item ${activeTab === 5 ? "active" : ""} ${!isCreated ? "disabled" : ""}`}
                        disabled={!isCreated}
                      >
                        <RiCarLine />
                        <span>Transfer</span>
                      </Tab>

                      <Tab
                        className={`package-tab-item ${activeTab === 6 ? "active" : ""} ${!isCreated ? "disabled" : ""}`}
                        disabled={!isCreated}
                      >
                        <RiCheckboxCircleLine />
                        <span>Includes</span>
                      </Tab>
                      <Tab
                        className={`package-tab-item ${activeTab === 7 ? "active" : ""} ${!isCreated ? "disabled" : ""}`}
                        disabled={!isCreated}
                      >
                        <RiCloseCircleLine />
                        <span>Excludes</span>
                      </Tab>
                      <Tab
                        className={`package-tab-item ${activeTab === 8 ? "active" : ""} ${!isCreated ? "disabled" : ""}`}
                        disabled={!isCreated}
                      >
                        <RiFileShieldLine />
                        <span>Terms & Conditions</span>
                      </Tab>
                      <Tab
                        className={`package-tab-item ${activeTab === 9 ? "active" : ""} ${!isCreated ? "disabled" : ""}`}
                        disabled={!isCreated}
                      >
                        <RiEyeLine />
                        <span>View Details</span>
                      </Tab>
                      <Tab
                        className={`package-tab-item ${activeTab === 10 ? "active" : ""} ${!isCreated ? "disabled" : ""}`}
                        disabled={!isCreated}
                      >
                        <RiLayoutLine />
                        <span>Templates</span>
                      </Tab>
                      <Tab
                        className={`package-tab-item ${activeTab === 11 ? "active" : ""} ${!isCreated ? "disabled" : ""}`}
                        disabled={!isCreated}
                      >
                        <RiGroupLine />
                        <span>Manage Applicants</span>
                      </Tab>


                    </TabList>
                  </Tabs>
                </div>

                <div className="package-tabs-content">
                  <Tabs selectedIndex={activeTab}>
                    <TabPanel>
                      {/* 3. PASS packageDetails to PackageForm */}
                      <PackageForm
                        key={packageId || "new"}
                        packageId={packageId}
                        isEditMode={isEditMode}
                        setIsEditMode={setIsEditMode}
                        onPackageCreated={(newId) => navigate(`/package/${newId}`)}
                        onAiPackageGenerated={handleAiPackageGenerated}
                        packageDetails={packageDetails} // Pass the prop here
                      />
                    </TabPanel>

                    <TabPanel>
                      <PackageItinerary packageId={packageId} />
                    </TabPanel>
                    <TabPanel>
                      {/* 3. PASS packageDetails to PackageFlightBooking */}
                      <PackageFlightBooking
                        packageId={packageId}
                        packageDetails={packageDetails} // Pass the prop here
                      />
                    </TabPanel>
                    <TabPanel>
                      <PackageHotelBooking packageId={packageId} />
                    </TabPanel>
                    <TabPanel>
                      <PackageSightSeeing packageId={packageId} />
                    </TabPanel>
                    <TabPanel>
                      <PackageTransfer packageId={packageId} />
                    </TabPanel>
                    <TabPanel>
                      <PackageInclude packageId={packageId} />
                    </TabPanel>
                    <TabPanel>
                      <PackageExclude packageId={packageId} />
                    </TabPanel>
                    <TabPanel>
                      <PackageTermsandCondition packageId={packageId} />
                    </TabPanel>
                    <TabPanel>
                       {/* 3. PASS packageDetails to PackageDetailsView */}
                      <PackageDetailsView
                        packageId={packageId}
                        packageDetails={packageDetails} // Pass the prop here
                        onEditRequest={handleTabSelect}
                      />
                    </TabPanel>
                     <TabPanel>
              
              <PackageTemplates 
                packageId={packageId} 
                packageDetails={packageDetails} // <-- PASS THE PROP HERE
              />
            </TabPanel>
                    <TabPanel>
                      <PackageManageApplicants packageId={packageId} />
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageComponent;